exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".checkbox-icon {\r\n    font-size: 15px;\r\n    color: #12408B;\r\n    cursor: pointer;\r\n    width: 15px;\r\n}\r\n\r\n.checkbox-disabled {\r\n    color: #d9d9d9;;\r\n    cursor: pointer;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/components/checkbox/checkbox.component.css
// module id = ../../../../../src/app/shared/components/checkbox/checkbox.component.css
// module chunks = main